import { CSSProperties, ReactNode } from "react";

import styles from "./BackgroundForm.module.css";
import useMyMontepioContext from "../Context/useMyMontepioContext";

type TBackgroundFormProps = { children: ReactNode; style?: CSSProperties };

export const BackgroundForm = ({ children, style }: TBackgroundFormProps) => {
  const { isMobileAuth } = useMyMontepioContext();

  const defaultStyle = isMobileAuth ? undefined : styles.card;
  const contentStyle = isMobileAuth ? undefined : styles.content;

  return (
    <div style={{ ...style }} className={defaultStyle}>
      <div className={contentStyle}>{children}</div>
    </div>
  );
};
